module.exports = {
    error: {
        en: "Error",
        fi: "Virhe"
    },
    markAsSold: {
        en: "Mark as Sold",
        fi: "Merkitse myydyksi"
    },/*
    markAsSelling: {
        en: "Mark as Selling",
        fi: "Merkitse myytäväksi"
    },*/
    sold: {
        en: "Sold",
        fi: "Myyty"
    },
    edit: {
        en: "Edit",
        fi: "Muokkaa"
    },
    delete: {
        en: "Delete",
        fi: "Poista"
    },
    store: {
        en: "store",
        fi: "kauppa"
    },/*
    share: {
        en: "Share",
        fi: "Jaa"
    },
    message: {
        en: "Message",
        fi: "Viesti"
    },*/
    storeContacts: {
        en: "Store contacts",
        fi: "Kauppayhteystiedot"
    },
    name: {
        en: "Name",
        fi: "Nimi"
    },
    contact: {
        en: "Contact",
        fi: "Yhteystieto"
    },
    languages: {
        en: "Languages",
        fi: "Kielet"
    },
    showContact: {
        en: "Show contact",
        fi: "Näytä yhteystiedot"
    },
    postNotFound: {
        en: "Post not found",
        fi: "Ilmoitusta ei löytynyt"
    },
    yes: {
        en: "Yes",
        fi: "Kyllä"
    },
    no: {
        en: "No",
        fi: "Ei"
    },
    ...require('./itemInfo')
};